import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { TourDoneKey, TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';

import DesignerIntroPopupComponent from 'webapp/components/designer/popup-designer-intro';

import TourBase from 'webapp/models-custom/tour';

export default class DesignerIntroTour extends TourBase {
	@service('popup') declare popupService: Service.Popup;

	static keyForPersistantDone = TourDoneKey.DESIGNER__INTRO;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLES_INTRO_DESIGNER_TOUR;

	override popupComponent = DesignerIntroPopupComponent;

	get id(): string {
		return TourId.DESIGNER__INTRO;
	}

	override get keyForPersistantDone(): string {
		return DesignerIntroTour.keyForPersistantDone;
	}

	override start(): void {
		super.start();

		this.popupService
			.createModal(this.popupComponent, {
				popupClass: 'popup-type-tour-designer',
				allowStacked: true,
			})
			.open();

		this.markDone(); // just one step, once seen, it's done
	}
}
